import type { SxProps } from "@mui/material";
import { Box, CircularProgress } from "@mui/material";

export interface LoadingBoxProps {
  size?: number;
  sx?: SxProps;
}

export const LoadingBox = ({ size = 40, sx }: LoadingBoxProps) => (
  <Box display="flex" justifyContent="center" alignItems="center" p={4} sx={sx}>
    <CircularProgress size={size} />
  </Box>
);
